<template>
  <el-dialog :title="title"
             :visible.sync="dialogVisible"
             custom-class="lx-dialog"
             :close-on-click-modal="false"
             @open="handleOpen">
    <el-form label-width="120px"
             :rules="rules"
             :model="form"
             ref="form">
      <el-row>
        <el-col :span="12">
          <el-form-item class="lx-f-i-display-as-cell"
                        label="步骤名称"
                        prop="orderName">
            <el-input class="l-d-no-border"
                      v-model="form.orderName"
                      placeholder="步骤名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item class="lx-f-i-display-as-cell"
                        label="资源类型">
            <el-radio class="l-d-radio-margin"
                      v-model="form.resourceType"
                      label="模型">模型</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item class="lx-f-i-display-as-cell"
                        label="选择资源"
                        prop="resourceName">
            <el-radio-group v-model="form.resourceName">
              <el-radio-button v-for="item of resourceNames"
                               :key="item.value"
                               :label="item.value">{{ item.name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item class="lx-f-i-display-as-cell"
                        label="动画序列号"
                        prop="processOrder">
            <el-input class="l-d-no-border"
                      v-model="form.processOrder"
                      placeholder="请输入动画序列号，仅允许输入数字"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button size="small"
                 @click="$emit('update:visible', false)">取 消</el-button>
      <lx-submit btn-size="small"
                 btn-type="primary"
                 :btn-disabled="isBtnDisabled"
                 @click.native="handleSubmitEditResult('form')">确 定</lx-submit>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import __ from '@/util/common-utils'
import Submitting from '@/components/common/Submitting'
export default {
  props: ['visible', 'processIdentity', 'apiIndentity', 'existOrder', 'processType'],

  data () {
    let validName = () => {
      return (rule, value, callback) => {
        if (value) {
          if (value.length <= 10) {
              return callback()
          } else {
              return callback(new Error('长度在 1 到 10 个字符'))
          }
        }
      }
    }
    let validNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('动画序列号不能为空！'))
      } else if (Number.isInteger(Number(value)) && Number(value) > 999) {
        return callback(new Error('动画序列号不能大于999！'))
      } else {
        let boolean = new RegExp(`^[1-9]\\d*$`).test(value)
        if (!boolean) {
          return callback(new Error('动画序列号只能是正整数！'))
        } else {
          callback()
        }
      }
    }
    return {
      form: { orderName: '', resourceType: '模型', resourceName: '', processOrder: '' },
      resourceNames: [],
      rules: {
        orderName: [{ required: false, validator: validName(), trigger: 'blur' }],
        resourceName: [{ required: true, message: '请选择资源', trigger: 'blur' }],
        processOrder: [{ required: true, validator: validNum, trigger: 'blur' }]
      },
      isBtnDisabled: false,
      order: null
    }
  },

  components: { 'lx-submit': Submitting },

  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    },
    edit () { return this.processIdentity.id },
    editText () { return this.processIdentity.id ? this.processIdentity.operate : '添加' },
    title () { return this.processType ? this.editText + this.processType + '步骤' : '添加工作顺序' },
    process () {
      if (this.processType === '拆解') {
        return 'processes'
      } else if (this.processType === '检测') {
        return 'detection'
      } else if (this.processType === '组装') {
        return 'assemble'
      } else {
        return 'processes'
      }
    }
  },

  methods: {
    handleOpen () {
      this.isBtnDisabled = false
      this.form.orderName = this.processIdentity.operate === '编辑' ? this.processIdentity.name : ''
      this.form.resourceType = '模型'
      if (this.processIdentity.operate === '追加') {
        this.form.processOrder = ''
      } else {
        this.form.processOrder = this.processIdentity.resourceNo
      }
      // 添加工作顺序时需要将记录最后一条的资源类型带入dialog；编辑和添加时需要回显当前行的资源类型
      if (this.edit) {
        this.form.resourceName = this.processIdentity.resource ? this.processIdentity.resource.value : ''
      } else {
        this.form.resourceName = this.processIdentity.lastResource
      }
      /** 添加的工作的顺序 */
      let addOrder = (_.max(this.existOrder) ? _.max(this.existOrder) : 0) + 1
      /** 编辑的工作顺序 */
      let editOrder = this.processIdentity.processOrder
      /** 追加的工作顺序 */
      let appendOrder = this.processIdentity.processOrder + 1
      if (!this.processIdentity.id) {
        this.order = addOrder
      } else if (this.processIdentity.id && this.processIdentity.operate === '编辑') {
        this.order = editOrder
      } else if (this.processIdentity.id && this.processIdentity.operate === '追加') {
        this.order = appendOrder
      }
      this.$xhrGet('/projects/models')
        .then(rs => {
          this.resourceNames = rs.data
        })
    },

    closeDialog () {
      this.$emit('edit-result', this.form)
      this.$emit('update:visible', false)
    },

    xhrAdd () {
      this.form.orderName = _.trim(this.form.orderName)
      if (!this.form.orderName) {
        this.$message.error('步骤名称不可为空!')
        return false
      }
      let realFormData = {
        name: this.form.orderName,
        resourceModelId: this.form.resourceName,
        resourceNo: this.form.processOrder
      }
      this.$xhrPost(`/projects/items/${this.apiIndentity}/${this.process}`, realFormData)
        .then(rs => {
          this.isBtnDisabled = false
          if (rs.code === 200) {
            this.form.orderName = ''
            this.form.resourceType = ''
            this.form.resourceName = ''
            this.closeDialog()
          } else if (rs.code === 409) {
            this.$message.error('重复工作顺序!')
          }
        })
    },

    xhrUpdate () {
      this.form.orderName = _.trim(this.form.orderName)
      if (!this.form.orderName) {
        this.$message.error('步骤名称不可为空!')
        return false
      }
      if (this.processIdentity.id && this.processIdentity.operate === '编辑') {
        let realFormData = {
          name: this.form.orderName === this.processIdentity.orderName ? null : this.form.orderName,
          resourceModelId: this.form.resourceName === this.processIdentity.resourceName ? null : this.form.resourceName,
          id: this.processIdentity.id,
          resourceNo: this.form.processOrder
        }
        if (__.isObjectPropertiesAllNull(realFormData)) {
          this.$message.error('请修改信息后提交')
          return
        }
        this.$xhrPost(`/projects/items/${this.apiIndentity}/${this.process}`, realFormData)
          .then(rs => {
            if (rs.code === 200) {
              this.form.orderName = ''
              this.form.resourceType = ''
              this.form.resourceName = ''
              this.closeDialog()
            } else if (rs.code === 409) {
              this.$message.error('重复工作顺序!')
            }
          })
      } else {
        let realFormData = {
          name: this.form.orderName === this.processIdentity.orderName ? null : this.form.orderName,
          resourceModelId: this.form.resourceName === this.processIdentity.resourceName ? null : this.form.resourceName,
          id: this.processIdentity.id,
          resourceNo: this.form.processOrder
        }
        if (__.isObjectPropertiesAllNull(realFormData)) {
          this.$message.error('请修改信息后提交')
          return
        }
        this.$xhrPost(`/projects/items/${this.apiIndentity}/${this.process}/append`, realFormData)
          .then(rs => {
            if (rs.code === 200) {
              this.form.orderName = ''
              this.form.resourceType = ''
              this.form.resourceName = ''
              this.closeDialog()
            } else if (rs.code === 409) {
              this.$message.error('重复工作顺序!')
            }
          })
      }
    },

    handleSubmitEditResult (formName) {
      this.isBtnDisabled = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.processIdentity.id ? this.xhrUpdate() : this.xhrAdd()
        } else {
          this.$message.error('请检查输入')
          this.isBtnDisabled = false
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.l-d-no-border /deep/ input::-webkit-outer-spin-button,
.l-d-no-border /deep/ input::-webkit-inner-spin-button{
   -webkit-appearance: none !important;
   margin: 0;
}
.l-d-no-border /deep/ input[type="number"]{-moz-appearance:textfield;}
</style>



// WEBPACK FOOTER //
// src/components/teaching/ProcessEditor.vue